/**
 * La configuración general del negocio (`order_form_config.general_config`): origen por defecto,
 * caja, aéreo, quién paga el flete. UNA lectura para todos (ADR-013): antes la hacían por su cuenta
 * `bulkRegisterShalom` y la pantalla de Entrega.
 */
import { supabase } from '@/lib/supabase';

export async function configGeneralDelNegocio(tenantId: string): Promise<Record<string, unknown>> {
  const { data } = await supabase.from('order_form_config').select('general_config').eq('tenant_id', tenantId).maybeSingle();
  return (data?.general_config as Record<string, unknown> | undefined) ?? {};
}
